import { z } from 'zod';
/**
 * Постраничный вывод с номерами страниц (offset/limit) — для источников,
 * которые сами пагинируют offset'ом и отдают `total` (API контент-движка).
 * Канон для Postgres-списков админки остаётся keyset-курсором
 * (`nextCursor` + «Показать ещё»): offset по живой таблице сдвигает строки
 * между запросами. Для контента это приемлемо — новая публикация в худшем
 * случае повторит строку на следующей странице.
 */
/** Размеры страницы, которые предлагает `Pagination` кита. */
export const OFFSET_PAGE_SIZES = [25, 50, 100, 200];
export const DEFAULT_OFFSET_PAGE_SIZE = 50;
/**
 * Предел номера страницы: защита от `?page=1e9` (offset в миллиарды строк —
 * полный проход коллекции движком ради пустого ответа).
 */
export const MAX_OFFSET_PAGE = 10_000;
/**
 * Размер страницы — строго из списка: произвольный `pageSize=5000` обходил
 * бы предел движка и выкачивал коллекцию одним запросом.
 */
export const OffsetPageSizeSchema = z.coerce.number().pipe(z.literal([...OFFSET_PAGE_SIZES], {
    message: `pageSize — одно из ${OFFSET_PAGE_SIZES.join(', ')}`,
}));
/**
 * `page` (с 1) и `pageSize` из query-string. Оба с умолчанием — для новых
 * маршрутов. Маршрут, где постраничный режим включается только явным
 * `page`/`pageSize` (окно выката старого бандла), берёт `OffsetPageQueryOptional`.
 */
export const OffsetPageQuery = z.object({
    page: z.coerce.number().int().min(1).max(MAX_OFFSET_PAGE).default(1),
    pageSize: OffsetPageSizeSchema.default(DEFAULT_OFFSET_PAGE_SIZE),
});
/** Те же поля без умолчаний: «не задано» отличимо от «первая страница». */
export const OffsetPageQueryOptional = z.object({
    page: z.coerce.number().int().min(1).max(MAX_OFFSET_PAGE).optional(),
    pageSize: OffsetPageSizeSchema.optional(),
});
/** `page/pageSize` → `offset/limit` источника. */
export const offsetOf = (q) => ({
    offset: (q.page - 1) * q.pageSize,
    limit: q.pageSize,
});
/**
 * Страница списка: `items`, `total` (всего строк под фильтром), `page`,
 * `pageSize`. `total` — `.nullable().default(null)`: источник может не
 * знать числа (тогда UI показывает только «Назад/Дальше»).
 */
export const offsetPage = (item) => z.object({
    items: z.array(item),
    total: z.number().int().nonnegative().nullable().default(null),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
});
/**
 * Поля страницы, добавленные к СУЩЕСТВУЮЩЕМУ ответу списка (публикации,
 * клипы): `.nullable().default(null)` — новый бандл в окне выката читает
 * ответ старого admin-api, где их нет.
 */
export const OffsetPageFields = {
    total: z.number().int().nonnegative().nullable().default(null),
    page: z.number().int().min(1).nullable().default(null),
    pageSize: z.number().int().min(1).nullable().default(null),
};
//# sourceMappingURL=paging.js.map